import { CategoryModalView } from '../../../javascripts/category_modal_mobile';
import Mute from '../../../javascripts/components/Mute';

const mute = new Mute({ isCardLayout: true });

document.addEventListener('DOMContentLoaded', () => {
  const categorySearch = document.querySelector("#announcement-category-search");
  const statusSearch = document.querySelector("#announcement-status-search");

  if (categorySearch) new CategoryModalView(categorySearch);
  if (statusSearch) new CategoryModalView(statusSearch);

  mute.setMuteActions({ dataType: 'User' });
  mute.addToggleMuteEvent();
  initializeToggleMuteComponentMutationObserver();
});

function initializeToggleMuteComponentMutationObserver() {
  const mutationObserver = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
      Array.from(mutation.addedNodes)
        .filter(node => node.nodeType === Node.ELEMENT_NODE)
        .forEach(node => {
          mute.setMuteActions({ dataType: 'User' });
        });
    });
  });
  const observeTarget = document.body;
  mutationObserver.observe(observeTarget, { childList: true });
}
